import type { ComponentContentSchema } from '@vibesites/runtime';
import {
  useBlockSlot,
  SectionContextProvider,
  EditableToken,
} from '@vibesites/runtime/react';

// ============================================================================
// Component
// ============================================================================

export function InteractiveMapSection() {
  const mapSlot = useBlockSlot('interactivemapsection.map_block', {
    defaultValue: 'apartment-sync-map',
  });

  return (
    <EditableToken
      path="interactivemapsection.map_block"
      as="div"
      className="min-h-[400px] md:min-h-[500px] flex flex-col bg-[var(--vibe-color-background)]"
    >
      {/* The ApartmentSync (Repli360 / RRAC) script appends its modal /
          popup shells directly to <body> and only hides them with JS a tick
          after they mount — leaving a brief flash of a dark overlay + close
          "X" at the top of the page while the widget loads. Default those
          body-level shells to hidden so the flash never paints. This is a
          plain (non-!important) rule, so the vendor's jQuery .show() still
          wins with an inline display when a user actually opens a modal. */}
      <style>{`
        body > .rrac_modal_container,
        body > .rrac-popup {
          display: none;
        }
      `}</style>
      {mapSlot ? (
        <SectionContextProvider sectionId={mapSlot.sectionId}>
          <mapSlot.BlockComponent sectionId={mapSlot.sectionId} />
        </SectionContextProvider>
      ) : (
        <div>No block selected</div>
      )}
    </EditableToken>
  );
}

// ============================================================================
// Schema
// ============================================================================

export const contentSchema: ComponentContentSchema = {
  slot: 'InteractiveMapSection',
  displayName: 'Interactive Map Section',
  tokens: {
    'interactivemapsection.map_block': {
      label: 'Map Block',
      type: 'block',
      defaultValue: 'apartment-sync-map',
      acceptedBlockCategories: ['Integrations'],
    },
  },
  slotGroups: {},
  collectionBindings: {},
};

(InteractiveMapSection as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default InteractiveMapSection;
